import { loadConfigsEarly, hasDataLayer } from './loader-utils';

// Ensure window.DDC exists
window.DDC = window.DDC || {};

// Listen for wsInvListingShown events that fire before the API is loaded,
// so the API can replay the events when it's ready.
window.DDC.APIEvents = {
	received: [],
	handleShown: data => {
		if (data) {
			window.DDC.APIEvents.received.push(data);
		}
	},
	start: () => {
		window.addEventListener(
			'wsInvListingShown',
			window.DDC.APIEvents.handleShown
		);
	},
	get: () => {
		return window.DDC.APIEvents.received;
	}
};
window.DDC.APIEvents.start();

const APILoader = class APILoader {
	constructor() {
		// Initialize but don't start loading yet
		this.configsPromise = null;
	}

	// Single method for loading configs - called by both APILoader and main API
	loadConfigs() {
		// Check if already loading/loaded
		window.DDC.PrivateAPI = window.DDC.PrivateAPI || {};
		if (window.DDC.PrivateAPI.integrationConfigs) {
			return window.DDC.PrivateAPI.integrationConfigs;
		}

		// Create the promise for loading configs
		this.configsPromise = this._fetchConfigs();

		// Store the promise immediately so other callers can reuse it
		window.DDC.PrivateAPI.integrationConfigs = this.configsPromise;

		return this.configsPromise;
	}

	async _fetchConfigs() {
		try {
			// Wait for DDC data structures to be available
			await hasDataLayer();

			// Load configs using the shared logic
			const configs = await loadConfigsEarly();

			// Once loaded, replace the promise with the actual data
			window.DDC.PrivateAPI.integrationConfigs = configs;

			// Dispatch event to notify that configs are ready
			window.dispatchEvent(
				new CustomEvent('WIAPIConfigsReady', { detail: configs })
			);

			return configs;
		} catch (error) {
			// Early config loading failed
			window.DDC.PrivateAPI.integrationConfigs = null;
			throw error;
		}
	}

	async isReady() {
		if (window.DDC.API) {
			return true;
		}
		return new Promise(resolve => {
			window.addEventListener('WIAPIReady', () => {
				resolve(true);
			});
		});
	}

	static async create(init = 'default-integration-id') {
		const apiLoader = new APILoader();
		await apiLoader.isReady();
		return new window.DDC.API(init);
	}

	// Start loading configs as soon as DDC data is available
	startEarlyLoading() {
		// This will check if already loading and return existing promise if so
		return this.loadConfigs();
	}
};

window.DDC.APILoader = APILoader;

// Create a singleton instance
window.DDC.apiLoaderInstance = new APILoader();

// Start loading configs as soon as DDC data is available
window.DDC.apiLoaderInstance.startEarlyLoading();

// Dispatch event to notify that the loader is ready
window.dispatchEvent(new Event('WIAPILoaderReady'));
